"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfiniteQueryData = void 0;
var isInfiniteQueryData = function (data) {
    return !!(data === null || data === void 0 ? void 0 : data.pages) && !!(data === null || data === void 0 ? void 0 : data.pageParams);
};
exports.isInfiniteQueryData = isInfiniteQueryData;
